<template>
  <a-spin :spinning="loading">
    <a-directory-tree :selectedKeys="selectedKeys" :treeData="treeData" @select="onSelect" />
  </a-spin>
</template>
<script>
  import { findAll } from '@/api/Api'

  export default {
    name: 'MenuTree',
    data() {
      return {
        treeData: [],
        treeList: [],
        selectedKeys: [],
        loading: false
      }
    },
    methods: {
      onSelect(selectedKeys) {
        this.selectedKeys = selectedKeys
        this.$emit('getDetailData', this.selectedKeys[0])
      },
      getTreeData(treeList) {
        const treeData = []
        treeList.forEach(item => {
          if (item.parent) {
            if (item.leaf) {
              treeData.push({ title: item.name, key: item.id, parentId: item.parent.id, leaf: item.leaf, methods: item.methods })
            } else {
              treeData.push({ title: item.name, key: item.id, parentId: item.parent.id, leaf: item.leaf })
            }
          } else {
            treeData.push({ title: item.name, key: item.id, parentId: item.parent, leaf: item.leaf })
          }
        })
        const parents = treeData.filter(value => value.parentId === 'undefined' || value.parentId == null)
        const children = treeData.filter(value => value.parentId !== 'undefined' && value.parentId != null)
        return this.translateDataToTree(parents, children)
      },
      translateDataToTree(parents, children) {
        //遍历父节点数据
        parents.forEach((parent) => {
          //遍历子节点数据
          children.forEach((current, index) => {
            //此时找到父节点对应的一个子节点
            if (current.parentId === parent.key) {
              const temp = JSON.parse(JSON.stringify(children))
              //让当前子节点从temp中移除，temp作为新的子节点数据，这里是为了让递归时，子节点的遍历次数更少，如果父子关系的层级越多，越有利
              temp.splice(index, 1)
              //把找到子节点放入父节点的children属性中
              typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
              //让当前子节点作为唯一的父节点，去递归查找其对应的子节点
              this.translateDataToTree([current], temp)
            }
          })
        })
        return parents
      },
      getSelectedKey() {
        const data = this.treeList.filter(item => item.id === this.selectedKeys[0])[0]
        if (data.parent) {
          let body={
            id:data.id,
            name: data.name,
          }
          this.$emit('sendSelectedKey', body)
        }

      },
      getSelectedParentKey() {
        const data = this.treeList.filter(item => item.id === this.selectedKeys[0])[0]
        if (data.parent) {
          this.$emit('sendSelectedParentKey', data.parent.id)
        }
      },
      getData() {
        this.$emit('loading', true)
        this.loading = true
        findAll('menuFactory', {}).then(res => {
          if (res.success) {
            this.treeList = res.result
            this.treeData = this.getTreeData(this.treeList)
          }
        }).finally(() => {
          this.loading = false
          this.$emit('loading', false)
        })
      },
      refresh() {
        this.getData()
        this.selectedKeys = []
      }
    }
  }
</script>
<style scoped>
</style>